import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const ICON_SIZE = 14;
const style = () => {
    const { colorIconError } = theme();
    return StyleSheet.create({
        container: {
            flex: 1,
        },
        icon: {
            fontSize: ICON_SIZE,
            fontWeight: 600,
            height: ICON_SIZE,
            lineHeight: ICON_SIZE,
            minHeight: ICON_SIZE,
            minWidth: ICON_SIZE,
            width: ICON_SIZE,
        },
        iconContainer: {
            backgroundColor: colorIconError,
        },
    });
};
export { style };
